import React from 'react';
import Body from '../Body/Body';
import About from '../About/About';
import Things from '../Things/Things';

function HomePage() {
  return (
    <>
      <Body />
      <About />
      <Things />
    </>
  );
}

export default HomePage;